import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IPtoPolicy } from "../../admin/pto_policies/shared/models/IPtoPolicy";
import { IHoliday } from "../../holiday/shared/models/IHoliday";
import { IPto } from "../../pto/shared/models/IPto";

const ptoHolidaysServiceUrl = "/api/pto/holiday";
const ptoPoliciesServiceUrl = "/api/pto/policy";
const ptoServiceUrl = "/api/pto/pto";

@Injectable({
  providedIn: "root",
})
export class PtoService {
  constructor(private http: HttpClient) { }

  getAllHolidays(year: string, country: string): Observable<IHoliday[]> {
    let params = new HttpParams()
      .set("year", year)
      .set("country", country);
    return this.http.get<IHoliday[]>(ptoHolidaysServiceUrl, { params });
  }
  getHoliday(holidayId: number) {
    let params = new HttpParams().set("holidayId", holidayId.toString());
    return this.http.get<IHoliday>(`${ptoHolidaysServiceUrl}/${holidayId}`, { params });
  }
  createHoliday(holiday: IHoliday) {
    return this.http.post<any>(ptoHolidaysServiceUrl, holiday);
  }
  updateHoliday(holiday: IHoliday){
    return this.http.put<any>(ptoHolidaysServiceUrl, holiday);
  }
  deleteHoliday(holidayId: number) {
    let params = new HttpParams().set("holidayId", holidayId.toString());
    return this.http.delete<any>(ptoHolidaysServiceUrl, { params });
  }

  getAllPolicies(country: string): Observable<IPtoPolicy[]> {
    let params = new HttpParams().set("country", country);
    return this.http.get<IPtoPolicy[]>(ptoPoliciesServiceUrl, { params });
  }
  getPolicy(policyId: number) {
    let params = new HttpParams().set("holidayId", policyId.toString());
    return this.http.get<IPtoPolicy>(`${ptoPoliciesServiceUrl}/${policyId}`, { params });
  }
  createPolicy(policy: IPtoPolicy) {
    return this.http.post<any>(ptoPoliciesServiceUrl, policy);
  }
  updatePolicy(policy: IPtoPolicy){
    return this.http.put<any>(ptoPoliciesServiceUrl, policy);
  }
  deletePolicy(policyId: number) {
    let params = new HttpParams().set("policyId", policyId.toString());
    return this.http.delete<any>(ptoPoliciesServiceUrl, { params });
  }
  addPto(pto: IPto, isManager: boolean) {
    return isManager ?
      this.http.post<IPto>(`${ptoServiceUrl}/addByManager`, pto)
      :
      this.http.post<IPto>(`${ptoServiceUrl}/add`, pto);
  }
  updatePto(pto: IPto) {
    return this.http.put<IPto>(`${ptoServiceUrl}/update`, pto);
  }
  verifyPto(pto: IPto) {
    return this.http.post<boolean>(`${ptoServiceUrl}/verify`, pto);
  }
  changeStatus(pto: IPto) {
    return this.http.put<IPto>(`${ptoServiceUrl}/changeStatus`, pto);
  }
  getUserPtos() {
    return this.http.get<IPto[]>(`${ptoServiceUrl}/get`);
  }
  getAllPtos() {
    return this.http.get<IPto[]>(`${ptoServiceUrl}/getAll`, { });
  }
  getPto(ptoId: number) {
    let params = new HttpParams().set("id", ptoId.toString());
    return this.http.get<IPto>(`${ptoServiceUrl}/edit`, { params });
  }
  getPtoBalance(userId: number, ptoId?: number): Observable<{ userId: number, balance: number }> {
    let params = new HttpParams();
    if (ptoId !== undefined && ptoId !== null) {
      params = params.set('ptoId', ptoId.toString());
    }
    return this.http.get<{ userId: number, balance: number }>(
      `${ptoServiceUrl}/getBalance/${userId}`,
      { params }
    );
  }
  getPtoHoursUsedYtd(userId: number, ptoId?: number): Observable<{ userId: number, ptoHoursUsedYtd: number }> {
    let params = new HttpParams();
    if (ptoId !== undefined && ptoId !== null) {
      params = params.set('ptoId', ptoId.toString());
    }
    return this.http.get<{ userId: number, ptoHoursUsedYtd: number }>(
      `${ptoServiceUrl}/getPtoHoursUsedYtd/${userId}`,
      { params }
    );
  }
  generateCalendarUrl(): Observable<{ url: string }> {
    return this.http.get<{ url: string }>(`${ptoServiceUrl}/createCalendarUrl`);
  }
}
